// Brand assets & institutional content for Common Ground Project ETS

export const LOGO_URL = "/cgp_logo.png";

export const DRIVE_FOLDER_URL = "https://drive.google.com/drive/u/0/folders/1wVoD1fOrWXjugpNoPcohQ1OjHKRWH3nU";

export const DOCS = { statuto: "/statuto-cgp.pdf", adesione: "/modulo-adesione-cgp.pdf" };
export const VIEW_ONLY_DOCS = ["statuto"];

export const IMG = {
  heroUnity: "/hero-home.webp",
  senegal: "/progetto-senegal.jpg",
  centro: "/progetto-centro.jpg",
  chiSiamo: "/chi-siamo.jpg",
};

export const GALLERY = [
  { src: "/gallery/issa1.jpg", w: 1564, h: 1564 },
  { src: "/gallery/issa21.jpg", w: 1080, h: 642 },
  { src: "/gallery/issa4.jpg", w: 1564, h: 1564 },
  { src: "/gallery/issa18.jpg", w: 1080, h: 1440 },
  { src: "/gallery/issa15.jpg", w: 1080, h: 1440 },
  { src: "/gallery/issa12.jpg", w: 1080, h: 1080 },
  { src: "/gallery/issa13.jpg", w: 1564, h: 1564 },
  { src: "/gallery/issa14.jpg", w: 1564, h: 1564 },
  { src: "/gallery/issa11.jpg", w: 1600, h: 1600 },
  { src: "/gallery/issa8.jpg", w: 1080, h: 812 },
  { src: "/gallery/issa9.jpg", w: 1564, h: 1564 },
  { src: "/gallery/issa3.jpg", w: 1564, h: 1564 },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/progetti", label: "Progetti" },
  { to: "/contatti", label: "Contatti" },
  { to: "/accedi", label: "Area soci" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Un terreno comune",
    body: "Common Ground Project promuove la conoscenza e la valorizzazione delle culture, delle tradizioni e delle lingue dei popoli, favorendo il dialogo interculturale e l'integrazione. Crediamo che il confronto sia il primo strumento di cooperazione.",
  },
  {
    n: "02",
    title: "Cooperazione e dignità",
    body: "Realizziamo interventi di cooperazione allo sviluppo a sostegno della nutrizione, della crescita, dell'istruzione e dello sviluppo dei minori e delle persone in condizione di svantaggio, in Italia e nel mondo.",
  },
  {
    n: "03",
    title: "Diritti e uguaglianza",
    body: "Operiamo per la promozione dei diritti umani fondamentali, della giustizia e dell'uguaglianza di genere e per il contrasto di ogni forma di discriminazione, di povertà e di disuguaglianza economica e sociale.",
  },
];

export const STATS = [
  { value: "6", label: "Ambiti statutari di intervento" },
];

export const ACTIVITIES = [
  { title: "Promozione culturale", desc: "Festival, mostre, conferenze, corsi di lingua e laboratori dedicati alle culture del mondo." },
  { title: "Cooperazione allo sviluppo", desc: "Progetti per l'istruzione, la salute e le condizioni di vita di minori e persone svantaggiate." },
  { title: "Aiuto umanitario", desc: "Interventi di emergenza e assistenza a popolazioni colpite da crisi, conflitti o calamità." },
  { title: "Diritti e uguaglianza", desc: "Promozione dei diritti umani, della giustizia e dell'uguaglianza di genere." },
  { title: "Adozioni a distanza", desc: "Programmi di sostegno educativo e psico-affettivo per i minori." },
  { title: "Turismo responsabile", desc: "Viaggi di conoscenza, scambi culturali e turismo consapevole." },
];

export const PROJECTS = [
  {
    id: "scuola-senegal",
    kicker: "Cooperazione allo sviluppo",
    title: "Sostegno agli studenti del Senegal",
    location: "Senegal",
    status: "In corso",
    lead:
      "Un programma di sostegno all'istruzione primaria rivolto ai bambini di una comunità rurale, con l'obiettivo di garantire continuità scolastica, materiali didattici e un pasto quotidiano.",
    goals: [
      "Copertura delle rette e del materiale scolastico per la frequenza dell'intero anno.",
      "Fornitura di materiale didattico e supporto alle attività educative.",
      "Sostegno alla nutrizione dei minori attraverso un pasto quotidiano.",
      "Monitoraggio periodico della frequenza e dei risultati scolastici.",
    ],
    cover: IMG.senegal,
    gallery: [],
  },
  {
    id: "centro-aggregazione",
    kicker: "Cultura e comunità",
    title: "Raccolta fondi per lo sviluppo di un centro di comunità",
    location: "Progetto in sviluppo",
    status: "In sviluppo",
    lead:
      "Il nuovo centro nasce come polo di aggregazione e cultura: un punto di riferimento per la comunità locale e un luogo di crescita educativa. È concepito come uno spazio flessibile e in evoluzione, destinato a diventare un cuore pulsante per la cultura e l'incontro, dove le attività verranno costruite insieme ai futuri frequentatori.",
    goals: [
      "Realizzazione di uno spazio polifunzionale per attività culturali, educative e sociali.",
      "Creazione di un punto di riferimento stabile e aperto per la comunità locale.",
      "Programmazione partecipata: attività definite insieme a chi frequenterà il centro.",
      "Sostenibilità e crescita progressiva degli spazi nel tempo.",
    ],
    cta: true,
    cover: IMG.centro,
    gallery: [],
  },
];

export const CONTACT = {
  org: "Common Ground Project ETS",
  email: "infocgp@protonmail.com",
  phone: "+39 346 727 2831",
};
